"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IlCustomIcons = void 0;
var icons_1 = require("../../shared/icons");
exports.IlCustomIcons = {
    MONARCH_BIBLE: {
        icon: icons_1.BibleIcon,
        backgroundColor: '#7686c5',
    },
    MONARCH_GEOGRAPHY: {
        icon: icons_1.GeographyIcon,
        backgroundColor: '#8dc740',
    },
    MONARCH_LANGUAGE: {
        icon: icons_1.LanguageArtsIcon,
        backgroundColor: '#fcb13b',
    },
    MONARCH_MATH: {
        icon: icons_1.MathIcon,
        backgroundColor: '#f37c7c',
    },
    MONARCH_SCIENCE: {
        icon: icons_1.ScienceIcon,
        backgroundColor: '#2ab5cd',
    },
    // --
    CALVERT_ELECTIVE: {
        icon: icons_1.ElectiveIcon,
        backgroundColor: '#7b52a3',
    },
    CALVERT_GEOGRAPHY: {
        icon: icons_1.GeographyIcon,
        backgroundColor: '#5ca446',
    },
    CALVERT_LANGUAGE: {
        icon: icons_1.LanguageArtsIcon,
        backgroundColor: '#f8b830',
    },
    CALVERT_MATH: {
        icon: icons_1.MathIcon,
        backgroundColor: '#d64757',
    },
    CALVERT_SCIENCE: {
        icon: icons_1.ScienceIcon,
        backgroundColor: '#007abc',
    },
    PROJECT_ICON: {
        icon: icons_1.ProjectIcon,
        backgroundColor: '#00000000',
    },
    OVERDUE_ICON: {
        icon: icons_1.OverdueIcon,
        backgroundColor: '#00000000',
    },
    STARTED_ASSIGNMENT_ICON: {
        icon: icons_1.StartedAssignmentIcon,
        backgroundColor: '#00000000',
    },
    LOCK_ICON: {
        icon: icons_1.LockIcon,
        backgroundColor: '#00000000',
    },
    CUSTOM: undefined,
};
